import { useCallback, useEffect, useState } from 'react';
import { ALL_ITEMS_PAGE_SIZE } from 'core/http/pagination';
import { Declaration } from 'store/declarations/declaration';
import { ICS2GoodsItemCategory, ICS2GoodsItemResponse } from 'store/declarations/eu/ics2/ics2-ens-declaration';
import { listIcs2EnsProducts } from 'store/products/client';

const useHouseGoodsItems = (declarationId: string | undefined, declaration: Declaration | undefined) => {
    const [houseGoodsItems, setHouseGoodsItems] = useState<ICS2GoodsItemResponse[]>([]);

    const refetchHouseGoodsItems = useCallback(async () => {
        if (!(declarationId && declaration?.ics2ENSDeclaration)) return;

        const response = await listIcs2EnsProducts(declarationId, ICS2GoodsItemCategory.HOUSE, {
            size: ALL_ITEMS_PAGE_SIZE,
        });

        setHouseGoodsItems(response?.list ?? []);
    }, [declarationId, declaration?.ics2ENSDeclaration]);

    useEffect(() => {
        refetchHouseGoodsItems();
    }, [refetchHouseGoodsItems]);

    return { houseGoodsItems, refetchHouseGoodsItems };
};

export default useHouseGoodsItems;
